import { ReactNode } from 'react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { DistributionPromo } from '../DistributionPromo/DistributionPromo'
import { ResumeDistributionLayoutContainer, ContentContainer } from './styles'

type Props = {
  children: ReactNode
}

export const ResumeDistributionLayout = (props: Props) => {
  const { children } = props
  const { isAboveTablet } = useMediaQueries()

  return (
    <ResumeDistributionLayoutContainer>
      <ContentContainer>{children}</ContentContainer>
      {isAboveTablet && <DistributionPromo />}
    </ResumeDistributionLayoutContainer>
  )
}
